import(/* webpackMode: "eager" */ "/codebuild/output/src1992295232/src/ui-directo/apps/prospects/src/app/error.tsx");
